const removeSvgOverElement = (frame) => {
  if (!frame) {
    return;
  }

  const contentDocument = frame.contentDocument;

  let svg;
  let removalCount = 0;

  let svgCoverElement = () => {
    svg = contentDocument.querySelector(
      '.hiddenSvgOverElement, .svgOverElement-end, .svgOverElement-start',
    );
    return svg;
  };

  while (svgCoverElement()) {
    const parentElement = svg.parentElement;
    parentElement.removeChild(svg);
    removalCount += 1;

    parentElement.normalize();
  }

  return removalCount;
};

export default removeSvgOverElement;
